<template>
    <div>
        <div class="advert" v-if="data.advert && data.advert._active">
            <span @click="submitBtn()" class="close_btn" data-spm="100302"></span>
            <h3 class="i" :class="data.advert._lenCss">{{data.advert.amount}}</h3>
            <div class="l-des">您有1张畅由付{{data.advert.amount}}元抵扣券<br/>请尽快使用</div>
            <!-- <div class="img"><img src="/static/css/index/180206/10@2x.png"/></div> -->
            <div class="btns">
                <a @click="submitBtn()" href="/finance/common/jump_page.html" class="submit_btn" data-spm="100303">现在去使用</a>
                <div @click="cancelBtn()" class="cancel_btn" data-spm="100304">不再提示</div>
            </div>
        </div>
        <div class="initFollow" v-if="data.follow && data.follow._active">
            <div id="follow-active">
                <div class="initFollow-img">
                    <a class="img" href="//m.changyoyo.com/event/2018/0514/downloadapp.html" data-spm="101601"><img src="../assets/img/cy-icon.png"/> <span>下载畅由APP</span> </a>
                    <div class="img" @click="followCY" data-spm="101602"><img src="../assets/img/cy-wx-code.png"/><span>关注“畅由平台”</span></div>
                </div>
                    <!-- <span @click="submitBtn()" class="close_btn" data-spm="100297"></span>
                    <div class="img"><img src="/static/css/index/180206/zjl_icon_014.png"/></div> -->
                <div class="btns">
                    <div @click="cancelBtn()" class="cancel_btn" data-spm="101603">近期不再提示</div>
                    <span @click="submitBtn()" class="close_btn-home" data-spm="101604"></span>
                </div>
            </div>
            <div class="wx-code" id="wxCode">
                 <div class="wx-code-content">
                     <img src="../assets/img/cy-wx-code.png"/>
                     <div class="long-press">长按识别二维码</div>
                     <div class="follow-cy">关注畅由平台</div>
                </div>
                <div>
                    <span @click="submitBtn()" class="close_btn-home" data-spm="101605"></span>
                </div>
            </div>
        </div>
        <div class="lottery" v-if="data.dosignin && data.dosignin._active">
            <span @click="submitBtn()" class="close_btn" data-spm="100299"></span>
            <div class="img"><img src="/static/css/index/180206/zjl_icon_015.png"/></div>
            <div class="btns">
                <div @click="submitBtn()" class="submit_btn" data-spm="100300"></div>
                <div @click="cancelBtn()" class="cancel_btn" data-spm="100301">不再提示</div>
            </div>
        </div>
        <div class="l-goldrenCheck" v-if="data.goldrenCheck && data.goldrenCheck._active">
            <span @click="submitBtn()" class="close_btn" data-spm="100305"></span>
            <div class="img"><img src="/static/css/index/180206/goldrenCheck.png"/></div>
            <div class="btns">
                <div @click="cancelBtn()" class="submit_btn" data-spm="100306"></div>
                <div @click="submitBtn()" class="cancel_btn" data-spm="100307">不再提示</div>
            </div>
        </div>
        <div class="l-takePacket" v-if="data.takePacket && data.takePacket._active">
            <span @click="submitBtn()" class="close_btn" data-spm="100308"></span>
            <h3>收到{{data.takePacket.packetTheme}}的红包</h3>
            <div class="l-weight">{{data.takePacket.packetShare}}{{data.takePacket.unitTxt}}</div>
            <div class="img"><img src="/static/css/index/180206/takePacket.png"/></div>
            <div class="btns">
                <a @click="submitBtn()" class="submit_btn" href="/gold/" data-spm="100309"></a>
                <div class="l-des">由{{data.takePacket.packetTheme}}活动获得</div>
            </div>
        </div>

        <div class="winMask" :style="hasActive"></div>
        <div class="tabBox">
            <template v-for="item in data">
                <div @click.prevent.stop="showWin(item._itemCss)" v-if="typeof item == 'object' && item._active != undefined" class="item" :class="item._itemCss" :data-spm="item._dataSpm"></div>
            </template>
        </div>
    </div>
</template>
<script>

import browser from "cy_static/browser";
import userUtil from "cy_static/userUtil";
import ajaxUtil from "cy_static/ajaxUtil";
    export default {
        name: 'pupWin',
        props: {
            duration: {// 延迟毫秒时
                type: String
            }
        },
        data: function () {
            !window.pupData && (window.pupData = {
                advert : {},
                follow : {},
                dosignin : {},
                goldrenCheck : {},
                takePacket : {},
                newMsg : {}
            })
            let _data = window.pupData;
            return {
                userToken : userUtil.get(),
                data: _data
            }
        },
        mounted (){
            let m = this;
            if (window.pupData.isInit) {
                return;
            }
            window.pupData.isInit = true;
            m.initFollow();
            userUtil.check_v1(function (token) {
                m.loginToken = token;
                if (!token) {
                    return;
                };
                m.advert();
                m.goldrenCheck();
                //m.dosignin();
                m.hasNewMsg();
            });

        },
        computed : {// 有弹出窗口显示遮盖层
            hasActive() {
                let m = this, _display = "none";
                for ( let key in m.data) {
                    if (m.data.hasOwnProperty(key) && m.data[key]._active) {
                        _display = "block";
                    }
                }
                return {display : _display}
            }
        },
        methods: {
            type(data, object) {
                return Object.prototype.toString.call(data) == "[object " + object + "]"
            },
            currDate(callback) {
                if(callback){
                    return callback();
                }else{
                // 今天晚上24点时间
                let date = new Date();
                return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
                }
            },
            getCurrObj () {// 当前弹出的窗口
                let m = this;
                for ( let key in m.data) {
                    if (m.data.hasOwnProperty(key) && m.type(m.data[key], "Object") && m.data[key]._active) {
                        return m.data[key];
                    }
                }
                return null;
            },
            submitBtn () {// 取消回调
                let obj = this.getCurrObj();
                if (obj) {
                    obj._active = false;
                    obj.submitBtn && obj.submitBtn(obj);
                }
            },
            cancelBtn () {// 不再提示回调
                let m = this;
                let obj = this.getCurrObj();
                if (obj) {
                    obj._active = false;
                    obj.cancelBtn && obj.cancelBtn(obj);
                    m.hideWin(obj);
                }
            },
            hideWin (obj) {
                let m = this;
                for ( let key in m.data) {
                    if (m.data.hasOwnProperty(key)  && m.type(m.data[key], "Object") && m.data[key] == obj) {
                        delete m.data[key];
                    }
                }
            },
            showWin (itemCss) {// 显示弹出窗口
                let m = this;
                for ( let key in m.data) {
                    if (m.data.hasOwnProperty(key) && m.type(m.data[key], "Object")) {
                        var obj = m.data[key];
                        obj._active = false;
                        if (obj._itemCss == itemCss) {
                            obj._active = true;
                        }
                    }
                }
            },
            initFollow () {// 关注APP
                 let m = this, dkey = "initFollow";
                 // browser.weixin &&
                 if ( !spm.util.cookie.get(dkey)) {
                    let obj  = {};
                    obj._active = false;
                    obj._itemCss = "item4";
                    obj._dataSpm = "101600";
                    m.data.follow = obj;
                    obj.cancelBtn = function () {
                        spm.util.cookie.set(dkey, 'true', {'expires': m.currDate(function(){
                             // 隔7天显示
                            let date = new Date();
                            let todayTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0).getTime();
                            //  加上7天毫秒数
                            let sevenDay = new Date(todayTime + 24*60*60*1000*7);
                            return new Date(sevenDay.getFullYear(), sevenDay.getMonth(), sevenDay.getDate(), 0, 0, 0);
                        })});
                    }
                    obj.submitBtn = function () {
                       document.querySelector('#follow-active').style.display = 'block';
                       document.querySelector('#wxCode').style.display = 'none';
                    }
                    m.data.follow = obj;
                 }
            },
            advert () {// 抵用券
                var m = this, URL, dkey;
                URL = "/pointgate/cashvoucher/advert";
                dkey = URL + m.userToken;
                if (!this.userToken || spm.util.cookie.get(dkey)) return;
                ajaxUtil.loadData(URL, {
                    method: "POST",
                    headers : {"content-type" :"application/json"},
                    body: {login_token: this.userToken}
                }).then(function (data) {
                    let obj = null;
                    data.respCode == "0000" && (obj = data.data);
                //    obj = {"advert":true,"openCh":false,"amount":5}// 测试数据测试数据测试数据
                    if (!obj || !obj.advert) {
                        return;
                    }
                    obj._active = true;
                    obj._itemCss = "item3";
                    obj._dataSpm = "100312";
                    obj.amount = parseFloat(obj.amount);
                    obj._lenCss = "len" + String(obj.amount).length;
                    obj.cancelBtn = function() {
                        spm.util.cookie.set(dkey, 'true');
                    }
                    m.data.advert = obj;
                })
            },
            dosignin () {// 幸运女神
                let m = this, URL, dkey;
                URL = '/sign/dosignin.htm';
                dkey = URL + m.userToken;
                if (m.userToken && !spm.util.cookie.get(dkey)) {
                    ajaxUtil.loadData(URL, {
                        method: "POST",
                        body: {reqTime : +new Date()}
                    }).then(function (data) {
//                       data = {ret : '0000',data:{}}
                        if (!data || !data.data || data.ret != '0000') {
                            return;
                        };
                        spm.util.cookie.set(dkey, 'true', {'expires':m.currDate()});
                        let obj = data.data;
                        obj._active = true;
                        obj._itemCss = "item1";
                        obj._dataSpm = "9999";
                        obj.submitBtn = function() {
                            spm.refresh('/lottery/game.htm');
                        }
                        m.data.dosignin = obj;
                    })
                }
            },
            goldrenCheck() {// 收到红包
                var m = this, URL, dkey;
                URL = "/pointgate/goldren/check";
                dkey = URL + m.userToken;
                if (!m.userToken || spm.util.cookie.get(dkey)) return;
                ajaxUtil.loadData(URL, {
                    method: "POST",
                    headers : {"content-type" :"application/json"},
                    body: {login_token: m.userToken}
                }).then(function (data) {
//                    data  = [{status:0,sync:1}]// 测试数据测试数据测试数据
                    let obj;
                    data = (Object.prototype.toString.call(data) == "[object Array]") ? data : '';
                    (data || []).forEach(function (item) {
                        if (!obj && item.status == 0 && item.sync == '1') {
                            obj = item;
                        }
                    });
                    if (!obj) {
                        return;
                    }
                    obj._active = false;
                    obj._itemCss = "item2";
                    obj._dataSpm = "100311";
                    obj.cancelBtn = function () {
                        m.goldrenTakePacket(obj);
                    }
                    obj.submitBtn = function(obj) {
                        m.hideWin(obj);
                        spm.util.cookie.set(dkey, 'true', {'expires':m.currDate()});
                    }
                    m.data.goldrenCheck = obj;
                })
            },
            goldrenTakePacket(__data) {// 领取红包
                var m = this;
                if (!m.userToken) return;
                ajaxUtil.loadData("/pointgate/goldren/takePacket", {
                    method: "POST",
                    headers : {"content-type" :"application/json"},
                    body: {login_token: m.userToken, packetIDs : __data.id}
                }).then(function (data) {
//                    data  = {status:1,packetTheme:"sss",packetShare:"sssd",unitTxt:77,packetTheme:"677"}// 测试数据测试数据测试数据
                    if (!data || data.status != '1') {
                        data.status == '2' && toast && toast('红包已过期！');
                        return;
                    }
                    let obj = data;
                    obj._active = true;
                    obj._itemCss = "item2";
                    obj._dataSpm = "";
                    m.data.takePacket = obj;
                })
            },
            hasNewMsg() {
                var m = this;
                if (!this.userToken) return;
                return ajaxUtil.loadData("/pointgate/msgcenter/hasNewMsg", {
                    method: "POST",
                    body: {login_token: this.userToken}
                }).then(function (data) {
//                    data  = {respCode:"0000",data:{data:{hasMsg:2}}}// 测试数据测试数据测试数据
                    let obj = {};
                    if (data.respCode == "0000") {
                        obj = (data.data) || {};
                    }

                  if (obj.hasMsg > 0) {
                        let item = document.querySelectorAll(".jfmall-tab .jfmall-item");
                        if (item && item[4]) {
                            item[4].classList.add("message");
                        }
                    }

                    m.data.newMsg = obj;
                })
            },
            followCY(){
                document.querySelector('#follow-active').style.display = 'none';
                document.querySelector('#wxCode').style.display = 'block';
            }
        }
    }
</script>
<style scoped>
    .winMask {position: fixed;top: 0;right: 0;bottom: 0;left: 0;z-index: 999;background-color: rgba(0,0,0,.7);display:none;}
    .tabBox{position: fixed;z-index: 998;right: 0;bottom: 115px;}
    .tabBox .item {width:1.02rem;height:0.79rem;background-repeat: no-repeat;background-size: 100% 100%;margin: 0.02rem 0;display:none;}
    .tabBox .item1{background-image:url(../assets/img/tag@2x.png); display:block;}
    .tabBox .item2{background-image:url(../assets/img/tag2@2x.png);display:block;}
    .tabBox .item3{background-image:url(../assets/img/tag3@2x.png);display:block;}
    .tabBox .item4{background-image:url(../assets/img/tag4@2x.png);display:block;    width: 1.22rem;
    height: 1rem;}
    /****抵用券****/
    .advert{position:fixed;left: 50%;margin-left: -3rem;z-index:1000;top:50%;width: 6rem;height: 6.66rem;margin-top: -3.3rem;background:url(../assets/img/bg.png) 0 -1.24rem no-repeat;background-size: 6rem;}
    .advert .close_btn{background-image:url(../assets/img/cancel@2x.png);background-repeat:no-repeat;background-size:0.61rem 1.09rem;width:0.62rem;height:1.09rem;display:block;position:absolute;top:-1.09rem;right:0;z-index:1000}
    .advert .close_btn-home {background-image:url(../assets/img/del-btn.png);background-repeat:no-repeat;background-size:0.61rem 1.09rem;width:0.62rem;height:1.09rem;display:block;position:absolute;top:-1.09rem;right:0;z-index:1000}
    .advert h3 {position: relative;font-size: 1.3rem;color: #fff;top: 2.2rem;text-shadow: 0 0 0.05em #fbfbfb;text-align: center}
    .advert h3.len1 {font-size: 1.3rem;}
    .advert h3.len1::before{content: '¥';display: inline-block;font-size: .9rem;font-weight: 100;padding-right: .05rem;}
    .advert h3.len3 {font-size: 1.17rem;left: 11%;top: 32%;}
    .advert h3.len4 {font-size: 0.86rem;left: 11%;top: 39%;}
    .advert h3.len5 {font-size: 0.70rem;left: 11%;top: 37%;}
    .advert h3.len6 {font-size: 0.60rem;left: 10%;top: 43%;}
    .advert .l-des{position: absolute;font-size: 0.32rem;font-family: SimHei;color: #FF6200;left: 1.2rem;top: 3.5rem;text-align: center;}
    /* .advert .img{width: 6.08rem;height: 2.86rem;} */
    /* .advert .img img{width:100%;display:block} */
    .advert .btns{}
    .advert .btns .submit_btn{width: 4.4rem;    height: 0.88rem; line-height: .88rem;text-align: center;   display: block;    position: absolute; font-size: .3rem;   z-index: 1000;    left: .8rem; color:  #FF6200;
    top: 4.7rem;background: url(../assets/img/but.png) 0 0 no-repeat;background-size: 4.4rem .88rem;}
    .advert .btns .cancel_btn{text-decoration: underline;font-size: 0.28rem;color: #F95948;letter-spacing: 0;text-align: center;font-family: SimHei;position: absolute;width: 100%;bottom: .4rem;}
    /****关注APP****/
    .initFollow{
        position:fixed;
        z-index:1000;
        padding-left: 0.6rem;
        padding-right: 0.6rem;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        }
    .initFollow .initFollow-img{
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
    .initFollow .initFollow-img >.img >span{
        margin-top: 0.3rem;
        display: inline-block;
        font-size:0.32rem;
        font-weight:400;
        color:rgba(255,255,255,1);
    }
    .initFollow .close_btn{background-image:url(../assets/img/cancel@2x.png);background-repeat:no-repeat;background-size:0.61rem 1.09rem;width:0.62rem;height:1.09rem;display:block;position:absolute;top:-1.09rem;right:0;z-index:1000}
    .initFollow .img{ text-align: center; }
    .initFollow .img img{width:2rem;height:2rem;display:inline-block}
    .initFollow .btns{
        text-align: center;
    }
    .initFollow .btns .submit_btn{width:2.91rem;height:0.7rem;display:block;position:absolute;z-index:1000;left:0.6rem;top:3.65rem}
    .initFollow .btns .cancel_btn{
        font-size: 0.26rem;
        font-weight: 400;
        color: rgba(255,255,255,1);
        padding-top: 0.92rem;
        text-align: center;
        text-decoration: underline;
    }
    .initFollow .close_btn-home{
        background-image:url(../assets/img/del-btn.png);
        background-repeat:no-repeat;
        background-size:0.61rem 1.09rem;
        width: 0.6rem;
        height: 0.6rem;
        display: inline-block;
        background-size: contain;
        margin-top: 0.7rem;
    }
    .initFollow .wx-code{
        text-align: center;
        display: none;
    }
    .initFollow .wx-code .wx-code-content {
        background: rgba(255,255,255,1);
        border-radius: 3px;
        display: inline-block;
        background: url(../assets/img/fingerprint-1.png) left top no-repeat,
                    url(../assets/img/fingerprint-2.png) right bottom no-repeat,
                    rgba(255,255,255,1);
    }

    .initFollow .wx-code .wx-code-content >img {
        width: 3.54rem;
        height: 3.54rem;
        margin: 0.48rem 0.78rem 0;
        border: 1px solid #D9D9D9;
    }
    .initFollow .wx-code .wx-code-content .long-press{
        padding-top: 0.18rem;
        font-size: 0.3rem;
        font-weight: 600;
    }
    .initFollow .wx-code .wx-code-content .follow-cy{
        font-size: 0.3rem;
        color: rgba(0,0,0,1);
        padding-top: 5px;
        padding-bottom: 0.42rem;
    }
    /****幸运女神****/
    .lottery{width:4.1rem;height:4.75rem;position:fixed;left:45%;margin-left:-2.05rem;z-index:1000;top:28%}
    .lottery .close_btn{background-image:url(../assets/img/cancel@2x.png);background-size:0.61rem 1.09rem;width:0.62rem;height:1.09rem;display:block;position:absolute;top:-1.09rem;right:0;z-index:1000}
    .lottery .img{width:4.1rem;height:4.75rem}
    .lottery .img img{width:100%;display:block}
    .lottery .btns{}
    .lottery .btns .submit_btn{width:2.91rem;height:0.7rem;display:block;position:absolute;z-index:1000;left:0.6rem;top:3.65rem}
    .lottery .btns .cancel_btn{text-decoration: underline;font-size: 0.36rem;color: #3399FF;letter-spacing: 0;text-align: center;font-family: SimHei;position: absolute;width: 100%;margin-top: 0.25rem;}
    /****收到红包****/
    .l-goldrenCheck{position:fixed;left: 45%;margin-left:-2.05rem;z-index:1000;top:28%;width: 4.91rem;height: 4.29rem;}
    .l-goldrenCheck .close_btn{background-image:url(../assets/img/cancel@2x.png);background-repeat:no-repeat;background-size:0.61rem 1.09rem;width:0.62rem;height:1.09rem;display:block;position:absolute;top: -.82rem;right:0;z-index:1000;}
    .l-goldrenCheck .img{width: 4.91rem;height: 4.29rem;}
    .l-goldrenCheck .img img{width:100%;display:block}
    .l-goldrenCheck .btns{position: absolute;width: 100%;height: 100%;top: 0;}
    .l-goldrenCheck .btns .submit_btn{width: 3.91rem;height: 0.9rem;display:block;position:absolute;z-index:1000;left: 0.5rem;top: 2.8rem;}
    .l-goldrenCheck .btns .cancel_btn{text-decoration: underline;font-size: 0.36rem;color: #3399FF;letter-spacing: 0;text-align: center;font-family: SimHei;position: absolute;width: 100%;margin-top: 0.25rem;top: 100%;}
    /****领红包****/
    .l-takePacket{position:fixed;left:45%;margin-left:-2.05rem;z-index:1000;top:28%;width: 4.91rem;height: 4.66rem;}
    .l-takePacket .close_btn{background-image:url(../assets/img/cancel@2x.png);background-repeat:no-repeat;background-size:0.61rem 1.09rem;width:0.62rem;height:1.09rem;display:block;position:absolute;top: -.82rem;right:0;z-index:1000;}
    .l-takePacket .img{width: 4.91rem;height: 4.66rem;}
    .l-takePacket .img img{width:100%;display:block}
    .l-takePacket h3 {position: absolute;font-size: 0.40rem;font-family: SimHei;color: #e14c28;left: 10%;right: 10%;top: 9%;font-weight: normal;text-overflow: ellipsis;white-space: nowrap;text-align: center;}
    .l-takePacket .l-weight {position: absolute;font-size: 0.40rem;font-family: SimHei;color: #e14c28;left: 28%;right: 28%;top: 25.5%;text-align: center;font-weight: bold;text-overflow: ellipsis;white-space: nowrap;}
    .l-takePacket .l-des {position: absolute;font-size: 0.18rem;font-family: SimHei;color: #6a1700;left: 10%;right: 10%;bottom: 2%;text-align: center;text-overflow: ellipsis;white-space: nowrap;}
    .l-takePacket .btns .submit_btn{width: 3.91rem;height: 0.9rem;display:block;position:absolute;z-index:1000;left: 0.5rem;top: 3.15rem;}
</style>
